module.exports = __webpack_public_path__ + "static/media/icons-PNG.049857e6.svg";